<template>
  <div id="chargingRateSetting" class="chargingRateSetting" v-loading.fullscreen.lock="pageLoading">
    <div class="main">
      <!-- Title -->
      <div class="title_bar">
        <div class="left">
          <div class="title">
            <div>{{ isSummer ? $t('EvCharging.SummerChargingSetting') : $t('EvCharging.NotSummerChargingSetting') }}</div>
          </div>
          <div class="tip">
            {{ tip }}
          </div>
        </div>
        <div class="right">
          <span class="tip">{{ $t('EvCharging.RequiredTip') }}</span>
        </div>
      </div>
      <div class="content">
        <div class="data-set-item mode-choose">
          <div class="title">
            <span class="tip">*</span>{{ $t('EvCharging.ModeChoose') }}
          </div>
          <div>
            <el-radio-group v-model="modeChoose">
              <el-radio key="fixed" label="fixed">
                <span>{{ $t('EvCharging.FixedMode') }}</span>
              </el-radio>
              <el-radio key="time" label="time">
                <span>{{ $t('EvCharging.TimeMode') }}</span>
              </el-radio>
            </el-radio-group>
          </div>
        </div>
        <template v-if="modeChoose === 'fixed'">
          <div class="data-set-item price-setting">
            <div class="title">
              <span class="tip">*</span>{{ $t('EvCharging.Rate') }}
            </div>
            <div class="input-content">
              <el-input-number
                :precision="2"
                :controls="false"
                v-model="fixedPrice"
                type="number"
                :placeholder="$t('EvCharging.RatePlaceholder')"
              />
              <span class="unit">{{ $t('EvCharging.DollarKWHUnit') }}</span>
            </div>
          </div>
        </template>
        <template v-else-if="modeChoose === 'time'">
          <div class="data-set-item price-setting">
            <div class="title">
              <span class="tip">*</span>{{ $t('EvCharging.HightRate') }}
            </div>
            <div class="input-content">
              <el-input-number
                :precision="2"
                :controls="false"
                v-model="timeOfUsePrice.height"
                type="number"
                :placeholder="$t('EvCharging.RatePlaceholder')"
              />
              <span class="unit">{{ $t('EvCharging.DollarKWHUnit') }}</span>
            </div>
          </div>
          <div class="data-set-item price-setting">
            <div class="title">
              <span class="tip">*</span>{{ $t('EvCharging.LowRate') }}
            </div>
            <div class="input-content">
              <el-input-number
                :precision="2"
                :controls="false"
                v-model="timeOfUsePrice.lower"
                type="number"
                :placeholder="$t('EvCharging.RatePlaceholder')"
              />
              <span class="unit">{{ $t('EvCharging.DollarKWHUnit') }}</span>
            </div>
          </div>
          <div class="data-set-item time-setting">
            <div class="title">
              {{ $t('EvCharging.HightTime') }}
            </div>
            <div class="input-content">
              <el-button
                size="mini"
                plain
                @click="openSelectTimeDialog"
              >
                {{ $t('EvCharging.ChooseHightTime') }}
              </el-button>
            </div>
          </div>
          <div class="data-set-item show-time">
            <div class="title"></div>
            <div class="table-content">
              <div class="time-range-display">
                <div v-for="day in weekday" :key="`display-${day.name}`" class="day">
                  <div class="table-title">
                    {{ day.display }}
                  </div>
                  <div class="content-block">
                    <div class="content">
                      <div v-for="time in timeData[day.name]" :key="time[0]" class="time-range">
                        {{ timeRange(time[0], time[1]) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="footer">
        <el-button
          @click="goBack"
          round
        >
          {{ $t('General.Cancel') }}
        </el-button>
        <el-button
          @click="confirm"
          round
          type="primary"
        >
          {{ $t('General.Confirm') }}
        </el-button>
      </div>
    </div>
    <SelectTimeDialog
      ref="selectTimeDialog"
      :timeData="timeData"
      @timeRangeSave="timeRangeSave"
    />
  </div>
</template>
<script>
import SelectTimeDialog from './components/SelectTimeDialog.vue'
import { apiEvCharging } from '@/api/EvCharging'

export default {
  components: {
    SelectTimeDialog
  },
  data () {
    return {
      pageLoading: true,
      isSummer: false,
      modeChoose: 'fixed',
      fixedPrice: undefined,
      timeOfUsePrice: {
        height: undefined,
        lower: undefined
      },
      weekday: [
        {
          dayIndex: 0,
          display: this.$t('EvCharging.Monday'),
          name: 'Monday'
        },
        {
          dayIndex: 1,
          display: this.$t('EvCharging.Tuesday'),
          name: 'Tuesday'
        },
        {
          dayIndex: 2,
          display: this.$t('EvCharging.Wednesday'),
          name: 'Wednesday'
        },
        {
          dayIndex: 3,
          display: this.$t('EvCharging.Thursday'),
          name: 'Thursday'
        },
        {
          dayIndex: 4,
          display: this.$t('EvCharging.Friday'),
          name: 'Friday'
        },
        {
          dayIndex: 5,
          display: this.$t('EvCharging.Saturday'),
          name: 'Saturday'
        },
        {
          dayIndex: 6,
          display: this.$t('EvCharging.Sunday'),
          name: 'Sunday'
        }
      ],
      timeData: {},
      originSettingData: {}
    }
  },
  computed: {
    tip () {
      if (this.isSummer) return this.$t('EvCharging.IsSummerTip')
      return this.$t('EvCharging.NotSummerTip')
    }
  },
  created () {
    this.isSummer = this.$route.params?.summer === 'summer'
    this.getRateSetting()
  },
  methods: {
    openSelectTimeDialog () {
      this.$refs.selectTimeDialog.openDialog()
    },
    async getRateSetting () {
      this.pageLoading = true
      apiEvCharging.RateSetting.getRateSetting().then(res => {
        if (res?.data?.Data?.Pricing) {
          this.formatResChargingRate(this.isSummer ? res.data.Data.Pricing.SummerChargingPrice : res.data.Data.Pricing.NonSummerChargingPrice)
          this.originSettingData = JSON.parse(JSON.stringify(res.data.Data))
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.pageLoading = false
      })
    },
    formatResChargingRate (data) {
      if (data?.FixedPrice) {
        this.modeChoose = 'fixed'
        this.fixedPrice = data.FixedPrice
      } else if (data?.TimeOfUsePrice) {
        this.modeChoose = 'time'
        let highPrice = 0
        let lowPrice = 0
        Object.values(data.TimeOfUsePrice).forEach((item) => {
          item.forEach((item2) => {
            if (item2.Price > highPrice) {
              lowPrice = highPrice
              highPrice = item2.Price
            } else if (item2.Price < highPrice && item2.Price !== lowPrice) {
              lowPrice = item2.Price
            }
          })
        })
        this.timeOfUsePrice.height = highPrice
        this.timeOfUsePrice.lower = lowPrice
        Object.keys(data.TimeOfUsePrice).forEach((key) => {
          this.timeData[key] = data.TimeOfUsePrice[key].filter((item) => item.Price === highPrice).map((item) => { return [item.BeginHour, item.EndHour] })
        })
      } else {
        this.modeChoose = 'fixed'
        this.fixedPrice = 0
      }
    },
    timeRange (start, end) {
      return `${start.toString().padStart(2, '0')}:00-${end.toString().padStart(2, '0')}:00`
    },
    timeRangeSave (data) {
      this.timeData = data
    },
    goBack () {
      this.$router.push({ name: 'rateSetting' })
    },
    confirm () {
      if (this.dataIsEmpty()) {
        this.$message.error(this.$t('EvCharging.RequiredCantEmpty'))
        return
      }
      if (this.dataIsIllegal()) {
        this.$alert(this.$t('EvCharging.DataIllegalAlertBody'), this.$t('EvCharging.DataIllegalAlertTitle'), {
          confirmButtonText: this.$t('General.OK'),
          type: 'error',
          callback: action => {}
        })
        return
      }
      if (this.dataIsZero()) {
        this.$message.error(this.$t('EvCharging.PriceCantZero'))
        return
      }
      const requestData = this.getUpdateRequestData()
      apiEvCharging.RateSetting.patchRateSetting(requestData).then(res => {
        if (!res.data.Data) this.goBack()
        else throw new Error(res.data.Data.errors)
      }).catch(e => {
        this.$message.error(this.$t('EvCharging.RateSettingFail'))
        console.log(e)
      })
    },
    dataIsEmpty () {
      if (this.modeChoose === 'fixed') {
        if (!this.fixedPrice) return true
      } else {
        if (!this.timeOfUsePrice.height) return true
        if (!this.timeOfUsePrice.lower) return true
      }
      return false
    },
    dataIsIllegal () {
      if (this.modeChoose === 'time') {
        if (this.timeOfUsePrice.height <= this.timeOfUsePrice.lower) return true
      }
      return false
    },
    dataIsZero () {
      if (this.modeChoose === 'fixed') {
        if (this.fixedPrice === 0) return true
      } else {
        if (this.timeOfUsePrice.height === 0) return true
        if (this.timeOfUsePrice.lower === 0) return true
      }
      return false
    },
    getUpdateRequestData () {
      const updateData = JSON.parse(JSON.stringify(this.originSettingData))
      let key = 'SummerChargingPrice'
      if (!this.isSummer) key = 'NonSummerChargingPrice'
      if (!updateData.Pricing[key]) updateData.Pricing[key] = {}
      if (this.modeChoose === 'fixed') {
        updateData.Pricing[key].TimeOfUsePrice = null
        updateData.Pricing[key].FixedPrice = this.fixedPrice
      } else {
        updateData.Pricing[key].FixedPrice = null
        Object.keys(this.timeData).forEach((timeKey) => {
          const allHourList = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24]
          const highPriceHour = []
          const priceData = []
          this.timeData[timeKey].forEach((item) => {
            for (let i = item[0]; i < item[1]; i++) {
              highPriceHour.push(i)
            }
            priceData.push({
              BeginHour: item[0],
              EndHour: item[1],
              Price: this.timeOfUsePrice.height
            })
          })
          let start = null
          allHourList.forEach((hour) => {
            if (start === null && !highPriceHour.includes(hour) && hour !== 24) start = hour
            if (highPriceHour.includes(hour) || hour === 24) {
              if (start !== null) {
                const end = hour
                priceData.push({
                  BeginHour: start,
                  EndHour: end,
                  Price: this.timeOfUsePrice.lower
                })
                start = null
              }
            }
          })
          if (!updateData.Pricing[key].TimeOfUsePrice) updateData.Pricing[key].TimeOfUsePrice = {}
          updateData.Pricing[key].TimeOfUsePrice[timeKey] = priceData
        })
      }
      delete updateData.Pricing.IdlePrice
      const requestData = {
        Changes: updateData
      }
      return requestData
    }
  }
}
</script>

<style lang="scss" scoped>
.chargingRateSetting {
  @include mainLayer();
  .title_bar {
    .right {
      .tip {
        color: $dangerColor !important;
      }
    }
  }
  .content {
    padding: 48px 32px;
    text-align: left;
    .data-set-item {
      display: flex;
      justify-content: left;
      margin-bottom: 20px;
      &.mode-choose,
      &.price-setting,
      &.time-setting {
        align-items: center;
      }
      &.price-setting {
        .input-content {
          display: flex;
          align-items: center;
          justify-content: left;
          gap: 8px;
        }
      }
      .title {
        width: 70px;
        min-width: 70px;
        text-align: right;
        margin-right: 16px;
        font-size: map-get($fontSize, small);
        font-weight: 600;
        color: $mainFontColor;
        .tip {
          color: $dangerColor;
        }
      }
      .table-content {
        width: 100%;
        .time-range-display {
          display: flex;
          width: 100%;
          border: 1px solid $borderDark1;
          border-radius: 8px;
          .day {
            flex: 1;
            .table-title {
              background-color: $bgGrayGreen;
              border-bottom: 1px solid $borderDark1;
            }
            .content {
              padding: 8px;
              .time-range {
                padding: 4px 0;
              }
            }
            >div {
              min-height: 50px;
              padding: 0px;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            &:not(:last-child) {
              border-right: 1px solid $borderDark1;
            }
            &:first-child {
              .title {
                border-radius: 8px 0 0 0;
              }
            }
            &:last-child {
              .title {
                border-radius: 0 8px 0 0;
              }
            }
          }
        }
      }
      .unit {
        font-size: map-get($fontSize, x-small);
        color: $mainFontColor;
        white-space: nowrap;
      }
    }
    ::v-deep .el-input-number {
      input {
        text-align: left;
      }
    }
  }
}
</style>
